import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './partnerPorsiHaji.action'

const initState = {
  ...baseInitState,
  params: {
    ...baseInitState.params,
    //   type haji
    financing_type_id: 1,
    // -----------------
  },
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('action').request:
      return {
        ...state,
        isLoadingSubmit: true,
      }
    case actionType('action').success:
      return {
        ...state,
        isLoadingSubmit: false,
      }
    case actionType('action').error:
      return {
        ...state,
        isLoadingSubmit: false,
      }
    default:
      return baseReducer(state, action, actionType)
  }
}
